import React from 'react';
import { Grid } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import { useParams } from 'react-router-dom';

import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import { getCommunityName, CustomTooltip } from './utils';
import { bitlyColors } from './data';
import { ChartHeading, ChartSubHeading, StyledPaper, LoadingWrapper } from './styles';

const DailyActiveUsers = ({
  organization,
  range,
  activeUsersRange,
  activeUserKeys,
  communityIndexActiveUsers,
}: {
  organization: any;
  range: number;
  activeUsersRange: any;
  activeUserKeys: any;
  communityIndexActiveUsers: any;
}) => {
  const { community: communityId }: any = useParams();

  return (
    <Grid item xs={12}>
      <StyledPaper>
        <ChartHeading>Daily Active Users by Community (Last {range} Days)</ChartHeading>
        <ChartSubHeading>
          This is a fully anonymous, aggregate count of active devices in this community based on exposure checks on the
          server.
        </ChartSubHeading>
        {!activeUsersRange.length ? (
          <LoadingWrapper>
            <CircularProgress />
          </LoadingWrapper>
        ) : (
          <ResponsiveContainer width="100%" height={320}>
            <BarChart
              barGap={0}
              data={activeUsersRange}
              margin={{
                top: 20,
                bottom: 0,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" interval="preserveStartEnd" />
              <YAxis />
              <Tooltip content={<CustomTooltip />} />
              <Legend />

              {activeUserKeys.includes(communityId) ? (
                <Bar
                  key={communityId}
                  barSize={20}
                  dataKey={getCommunityName(communityId, organization?.name)}
                  stackId="a"
                  fill={bitlyColors[communityIndexActiveUsers]}
                />
              ) : (
                activeUserKeys.map((label: string, index: number) => (
                  <Bar
                    key={label}
                    barSize={20}
                    dataKey={getCommunityName(label, organization?.name)}
                    stackId="a"
                    fill={bitlyColors[index]}
                  />
                ))
              )}
            </BarChart>
          </ResponsiveContainer>
        )}
      </StyledPaper>
    </Grid>
  );
};

export default DailyActiveUsers;
